<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <undertime-form>
            </undertime-form> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import undertimeForm from './todo-undertime-form'
export default {
    components: {
        undertimeForm
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-undertime-form.vue